<script>
import MultiSelectOld from './MultiSelectOld.vue'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: MultiSelectOld, // End of Component > extends
    /*
    |--------------------------------------------------------------------------
    | Component > inject
    |--------------------------------------------------------------------------
    */
    inject: {
        $validator: '$validator',
    }, // End of Component > inject

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            defaultValue: null,
        }
    },
    computed: {
        /**
         * format the ISD Codes list as required
         *
         * @return {void}
         */
        formatOptions() {
            // const key = this.$store.getters.getField(this.field.key)
            const key = this.$store.getters.getField("contactInfo.isdCountryCodeId")
            if (!key) {
                if (!this.defaultValue) {
                    if (
                        this.options &&
                        this.options.length &&
                        this.options.length > 0
                    ) {
                        const index = this.options.findIndex((e) => {
                            if (e.isdCode == '+92') {
                                return true
                            }
                        })
                        this.defaultValue = this.options[index]
                        // this.writeValue(this.defaultValue)
                    }
                }
            } else {
                if (
                    this.options &&
                    this.options.length &&
                    this.options.length > 0
                ) {
                    const index = this.options.findIndex((e) => {
                        if (e._id == key) {
                            return true
                        }
                    })

                    this.defaultValue = this.options[index]
                    this.writeValue(this.defaultValue)
                }
            }

            return this.options.map((option) => {
                return {
                    isdCode: option.isdCode,
                    isdCodeTitle: `${option.isdCode} (${option.title})`,
                    _id: option._id,
                }
            })
        }, // End of formatOptions() method
        model: {
            /**
             * Getter to get value for computed property
             * using props from parent componennt
             *
             * @return {mix}
             */
            get: function () {
                // console.log("value  ",this.value)
                // console.log("key ", this.$store.getters.getField(this.field.key))
                // return this.$store.getters.getField("contactInfo.countryCodeForCodeOnly")
                return this.value
            }, // End of get() method
            /**
             * Setter to set value for computed property
             * notifying the parent component
             *
             * @return {void}
             */
            set: function (newValue) {
                this.value = newValue
                // console.log("KEY : " , this.field.key,newValue)
                this.$store.commit('updateField', {
                    key: this.field.key,
                    value: newValue,
                })
                // this.$store.commit('updateField', {
                //     key: "contactInfo.countryCodeForCodeOnly",
                //     value: newValue,
                // })
            }, // End of set() method
        },
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        model(value) {
            // debugger

            if (value) {
                let selectedItem = this.options.find(
                    (item) => item._id === value._id
                )
                
                // this.$store.commit('updateField', {
                //     key: 'contactInfo.isdCode',
                //     value: selectedItem._id,
                // })
                // console.log('------model---------',this.field.key,selectedItem)
                this.$store.commit('updateField', {
                    key: 'countryCode',
                    value: selectedItem,
                })
                this.$store.commit('updateField', {
                    key: this.field.key,
                    value: selectedItem._id,
                })
                this.$store.commit('updateField', {
                    key: "contactInfo.isdCountryCodeId",
                    value: selectedItem._id,
                })
            }
        },
    }, // End of Component > watch

    mounted() {
        
       if(this.field.customerDetails){
           var some = this.field.key.split('.')
           if (this.field.customerDetails[some[0]][some[1]]){
               this.model = this.field.customerDetails[some[0]][some[1]]
           }
           // this.model =this.field.customerDetails['countryCode']
       }
    },

    methods: {
        /*
        |--------------------------------------------------------------------------
        | Manually setting the value of Dropdown
        |--------------------------------------------------------------------------
        */
        writeValue(newValue) {
            this.value = newValue
            if (this.field.isLocked) {

                // console.log('------newValue---------',this.field.key,newValue)


                this.$store.commit('updateField', {
                    key: this.field.key,
                    value: newValue.isdCode,
                })
                this.$store.commit('updateField', {
                    key: "contactInfo.isdCountryCodeId",
                    value: newValue._id,
                })
            }
        }, // End of Method > writeValue
    }, // End of Component > mounted
}
</script>
